import { identificarLinhaOrcamento } from './linhaOrcamentoIdentificacaoPolicy';

// Local do pagamento é uma escolha da linha; não é moeda ou nacionalidade.
const CNPJ_ACCESS = '21415772000164';

export function normalizarPagamentoExterior(value) {
    if (value === undefined || value === null || value === '') return null;
    if (value === true || value === 1 || value === '1') return true;
    if (value === false || value === 0 || value === '0') return false;
    throw new Error('Local do pagamento inválido. Selecione Brasil, Exterior ou Não informado.');
}

export function valorSeletorPagamentoExterior(value) {
    const normalizado = normalizarPagamentoExterior(value);
    return normalizado === null ? '' : normalizado ? 'exterior' : 'brasil';
}

// Evento NACIONAL (treinamento turma 5, 20/10): a linha sem local informado aparece como "Brasil" — no
// cálculo e nos Excel só `pagamento_exterior === true` vale como exterior, então "Não informado" e "Brasil"
// já dão o mesmo resultado. O dado não muda; escolher "Brasil" grava false como antes.
export function eventoNacional(nacionalidade) {
    return String(nacionalidade ?? '').trim().toLowerCase() === 'nacional';
}

export function valorSeletorLocalPagamento(value, { nacional = false } = {}) {
    const valor = valorSeletorPagamentoExterior(value);
    return nacional && valor === '' ? 'brasil' : valor;
}

// Bloco "Moeda e câmbio" da linha no evento nacional: só quando a linha é paga no exterior ou já tem moeda
// estrangeira própria em alguma etapa (para não esconder dado que já existe).
export function mostrarMoedaCambioNoNacional({ exterior = false, cambioProprio = false, moedasEtapa = [] } = {}) {
    if (exterior) return true;
    return !!cambioProprio && moedasEtapa.some((moeda) => moeda && moeda !== 'real');
}

export function pagamentoExteriorDoSeletor(value) {
    if (value === '') return null;
    if (value === 'exterior') return true;
    if (value === 'brasil') return false;
    throw new Error('Local do pagamento inválido.');
}

export function fornecedorAccessInterno(fornecedor, cadastroAccess = null) {
    const cnpj = String(fornecedor?.cnpj ?? '').replace(/\D/g, '');
    const id = fornecedor?.id ?? fornecedor;
    return cnpj === CNPJ_ACCESS || (cadastroAccess?.id != null && id != null && String(id) === String(cadastroAccess.id));
}

export function fornecedorIncompativelComPagamentoExterior(fornecedor, pagamentoExterior, cadastroAccess = null) {
    try {
        return normalizarPagamentoExterior(pagamentoExterior) === true && fornecedorAccessInterno(fornecedor, cadastroAccess);
    } catch (error) {
        return false;
    }
}

export function alterarPagamentoExteriorLinha(orcamento, indexGrupo, indexLinha, value, cadastroAccess = null) {
    const linha = orcamento.orcamentoitem?.[indexGrupo]?.subitem?.[indexLinha];
    if (!linha) throw new Error('Linha do orçamento não encontrada.');
    const normalizado = normalizarPagamentoExterior(value);
    if (normalizado === true && fornecedorAccessInterno(linha.fornecedor, cadastroAccess)) {
        throw new Error('Serviços internos da Access não podem ser marcados como pagamento no exterior.');
    }
    return {
        ...orcamento,
        orcamentoitem: orcamento.orcamentoitem.map((grupo, g) => g !== indexGrupo ? grupo : {
            ...grupo,
            subitem: grupo.subitem.map((subitem, s) => s !== indexLinha ? subitem : { ...subitem, pagamento_exterior: normalizado }),
        }),
    };
}

// Mantém a alternância reversível no estado da tela e limpa os contratos somente
// na fronteira de persistência quando o destino final não é Exterior.
export function prepararPagamentoExteriorPayload(orcamento = {}) {
    return {
        ...orcamento,
        orcamentoitem: (orcamento.orcamentoitem || []).map((grupo) => ({
            ...grupo,
            subitem: (grupo.subitem || []).map((linha) => {
                const pagamentoExterior = normalizarPagamentoExterior(linha.pagamento_exterior);
                return pagamentoExterior === true
                    ? { ...linha, pagamento_exterior: true }
                    : { ...linha, pagamento_exterior: pagamentoExterior, remessa_estimativa: null, fechamento_exterior: null };
            }),
        })),
    };
}

// Item 13: pendências localizadas (grupo/linha), TODAS as linhas, para o alerta levar o usuário
// ao "Local do pagamento" de cada uma. Regra inalterada.
export function listarPendenciasPagamentoExterior(orcamento = {}, cadastroAccess = null) {
    const pendencias = [];
    (orcamento.orcamentoitem ?? []).forEach((grupo, grupoIndex) => (grupo?.subitem ?? []).forEach((linha, linhaIndex) => {
        if (fornecedorIncompativelComPagamentoExterior(linha?.fornecedor, linha?.pagamento_exterior, cadastroAccess)) {
            pendencias.push({
                mensagem: `${identificarLinhaOrcamento(grupo, linhaIndex, linha)}: serviços internos da Access não podem ser marcados como pagamento no exterior. Selecione Brasil ou Não informado nessa linha.`,
                grupoIndex, linhaIndex, etapa: null, campo: 'local_pagamento',
            });
        }
    }));
    return pendencias;
}

export function validarPagamentoExterior(orcamento = {}, cadastroAccess = null) {
    return listarPendenciasPagamentoExterior(orcamento, cadastroAccess)[0]?.mensagem ?? null;
}
